import { Helmet } from 'react-helmet-async';
import { OverviewWithProvider } from 'src/components/visibility';

export default function VisibilityOverview() {
  return (
    <>
      <Helmet>
        <title>Visibility Overview</title>
      </Helmet>

      <OverviewWithProvider />
    </>
  );
}
